module.exports = __webpack_public_path__ + "europa-20-watermark.jpg?cb0ed2a7e84d7f80e52b3f2b807b6b2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-watermark.jpg
// module id = 305
// module chunks = 0